import { createSelector } from 'reselect'
import isDisabledByIdVariantSelectorUtil from 'modules/variant/redux/selectors/is-disabled-by-id/utils'
import hasSampledAndRatedVariantSelector from 'modules/variant/redux/selectors/has-sampled-and-rated'
import isAvailableProductVariantUtil from 'modules/product-variant/utils/is-available'

/**
 * @param props
 * @param {ProductVariantCollection} props.productVariant
 * @param {boolean} props.isGiftCard
 * @returns {(state) => boolean}
 */
const isDisabledByIdVariantSelector = ({
  productVariant,
  isGiftCard
}) => createSelector(
  hasSampledAndRatedVariantSelector(productVariant?.variant_id),
  (
    hasSampledAndRated
  ) => isDisabledByIdVariantSelectorUtil({
    isAvailable: (
      isAvailableProductVariantUtil(productVariant) ||
      isGiftCard
    ),
    hasSampledAndRated
  })
)

export default isDisabledByIdVariantSelector
